import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/tab/tab.js'

const tagName = 'dap-ds-tab'

/**
 * `dap-ds-tab`
 * @summary A tab item component. It is used in dap-ds-tab-group component slot to create a tab item.
 * @element dap-ds-tab
 * @title - Tab
 * *
 * @slot - The tab title template.
 * @slot content - The tab content.
 *
 * @csspart base - The main tab content container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTab',
})

export default reactWrapper
